import { keys } from "../common/util/ObjectEntries";
import { TNodeID } from "./_generated/NodeTypes";
import {
  useSharedState,
  useSharedStateReadOnly,
  useSharedStateWriteOnly,
} from "./app/useSharedState";
import { getControlHandleId } from "./Control";
import { GridControl } from "./controls/GridControl";
import { Wire } from "./Wire";
import "./Workspace.css";

type TProps = {
  rootId: TNodeID<"app">;
};

export default function Workspace({ rootId }: TProps) {
  const [appMousePosition] = useSharedStateReadOnly("appMousePosition");
  const [sceneMousePosition] = useSharedStateReadOnly("sceneMousePosition");
  const [, setContextMenu] = useSharedStateWriteOnly("activeContextMenu");
  const [scene, setScene] = useSharedState("scene");
  const [selection, setSelection] = useSharedState("selection");
  const [holdingState] = useSharedStateReadOnly("holdingState");

  let holdingWire = null;
  if (holdingState !== null && holdingState.type === "edit_wire") {
    let start;
    let end;
    if (holdingState.holdingSide === "start") {
      start = appMousePosition;
      const bounds = document
        .getElementById(
          getControlHandleId(holdingState.connectedControl, "left")
        )!
        .getBoundingClientRect();
      end = [bounds.left, bounds.top];
    } else {
      end = appMousePosition;
      const bounds = document
        .getElementById(
          getControlHandleId(holdingState.connectedControl, "right")
        )!
        .getBoundingClientRect();
      start = [bounds.right, bounds.top];
    }
    holdingWire = (
      <Wire points={[start[0], start[1], end[0], end[1]]} pathId="holding" />
    );
  }

  return (
    <div
      className="workspace"
      onKeyDown={(e) => {
        if (e.key === "Backspace" || e.key === "Delete") {
          if (selection === null) {
            return;
          }
          if (selection.controls.every((v) => canRemoveControl(scene, v))) {
            let newScene = scene;
            for (const id of selection.controls) {
              newScene = removeControl(scene, id);
            }
            setScene(newScene);
            setSelection(null);
            setContextMenu(null);
          }
        }
      }}
    >
      <div
        className="workspace-background"
        onContextMenu={(e) => {
          e.preventDefault();
          // setContextMenu({
          //   type: "background",
          //   position: appMousePosition,
          //   positionInScene: sceneMousePosition,
          // });
          setContextMenu({
            type: "control",
            position: appMousePosition,
            controlId: rootId,
          });
        }}
      />
      <div>
        {/* {Object.values(scene.nodes[rootId].children.surfaces).map(
          ({ id, position }) => {
            return (
              <div
                key={id}
                style={{
                  position: "absolute",
                  left: position[0],
                  top: position[1],
                }}
              >
                <Control controlId={id} />
              </div>
            );
          }
        )} */}
        {/* <ControlGridList list={scene.nodes[rootId].children.surfaces} /> */}
        {keys(scene.nodes[rootId].children.surfaces).map((v) => (
          <GridControl id={v} />
        ))}
        {/* {Object.keys(scene.wires).map((v) => {
          const { start, end } = scene.wires[v];
          const startBounds = document
            .getElementById(getControlHandleId(start, "right"))!
            .getBoundingClientRect();
          const endBounds = document
            .getElementById(getControlHandleId(end, "left"))!
            .getBoundingClientRect();
          return (
            <Wire
              key={v}
              points={[
                startBounds.right,
                startBounds.top,
                endBounds.left,
                endBounds.top,
              ]}
              pathId={v}
              wireId={v}
            />
          );
        })} */}
        {holdingWire}
      </div>
    </div>
  );
}
